import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { useTemplateStore } from 'Hooks/zustand/useTemplateStore';
import { getListById } from 'Services';
import { RQ_LIST_BY_ID } from 'Utils';
import { addFormattedProperty } from './util';

function useGetListById(id: number, users?: UsersHashmap) {
    const { t } = useTranslation();
    const { templateRepositoryId } = useTemplateStore.getState().template;

    return useQuery([RQ_LIST_BY_ID, id], () => getListById(id, { templateRepositoryId: templateRepositoryId! }), {
        enabled: !!(templateRepositoryId && templateRepositoryId > 0),
        select: addFormattedProperty(t, users)
    });
}

export default useGetListById;
